import { gql } from "apollo-angular";

export const ASSET_FRAGMENT = gql`
    fragment Asset on Asset {
        id
        width
        height
        name
        preview
        focalPoint {
            x
            y
        }
    }
`;

export const ORDER_ADDRESS_FRAGMENT = gql`
    fragment OrderAddress on OrderAddress {
        fullName
        company
        streetLine1
        streetLine2
        city
        province
        postalCode
        country
        countryCode
        phoneNumber
    }
`;

export const ADD_TO_CART_ORDER_SUMMARY_FRAGMENT = gql`
    fragment AddToCartOrderSummary on Order {
        id
        totalQuantity
        subTotal
    }
`;

export const CART_FRAGMENT = gql`
    fragment Cart on Order {
        id
        code
        state
        active
        updatedAt
        orderPlacedAt
        aggregateOrderId
        subTotal
        subTotalWithTax
        fulfillments {
            trackingCode
            state
            method
        }
        aggregateOrder {
            id
            code
            state
            total
            totalWithTax
        }
        sellerOrders {
            id
            code
            customFields {
                isMain
            }
            lines {
                id
                productVariant {
                    id
                    pricing {
                        id
                    }
                }
            }
        }
        customFields {
            isMain
            isConsolidatedFeed
            invoiceUrl
            trackingNumbers
        }
        payments {
            id
            state
            amount
            method
        }
        lines {
            id
            customFields {
                isConsolidatedFeedLine
                supplierId
            }
            featuredAsset {
                ...Asset
            }
            unitPrice
            unitPriceWithTax
            quantity
            linePriceWithTax
            discountedLinePriceWithTax
            discountedUnitPriceWithTax
            productVariant {
                id
                name
                sku
                product {
                    slug
                    customFields {
                        gtin
                        quantityPerBox
                    }
                }
                stockLevels {
                    stockOnHand
                    stockAllocated
                }
                isDeleted
                moq
                preOrderShippingDate
                pricing {
                    id
                    mov
                    currency
                    promotionDescription
                    promotionTextColor
                    supplyType
                    leadTimeFrom
                    leadTimeTo
                    prePaymentPercentage
                    fullPackageOnly
                    shippingDate
                    volumeDiscounts
                }
                pricingProduct {
                    minQ
                    maxQ
                }
                facetValues {
                    code
                    name
                    facet {
                        code
                        name
                    }
                }
            }
            discounts {
                amount
                amountWithTax
                description
                adjustmentSource
                type
            }
        }
        totalQuantity
        subTotal
        subTotalWithTax
        total
        totalWithTax
        shipping
        shippingWithTax
        shippingLines {
            priceWithTax
            shippingMethod {
                id
                code
                name
                description
            }
        }
        discounts {
            amount
            amountWithTax
            description
            adjustmentSource
            type
        }
        surcharges {
            sku
            description
            priceWithTax
        }
        shippingAddress {
            ...OrderAddress
        }
        billingAddress {
            ...OrderAddress
        }
    }
    ${ASSET_FRAGMENT}
    ${ORDER_ADDRESS_FRAGMENT}
`;

export const COUNTRY_FRAGMENT = gql`
    fragment Country on Country {
        id
        code
        name
        enabled
    }
`;

export const ADDRESS_FRAGMENT = gql`
    fragment Address on Address {
        id
        fullName
        company
        streetLine1
        streetLine2
        city
        province
        postalCode
        country {
            id
            code
            name
        }
        phoneNumber
        defaultShippingAddress
        defaultBillingAddress
    }
`;

export const ERROR_RESULT_FRAGMENT = gql`
    fragment ErrorResult on ErrorResult {
        errorCode
        message
        ... on InvalidCredentialsError {
            authenticationError
        }
    }
`;

export const ADD_TO_CART = gql`
    mutation AddToCart(
        $variantId: ID!
        $qty: Int!
        $customFields: OrderLineCustomFieldsInput
    ) {
        addItemToOrder(
            productVariantId: $variantId
            quantity: $qty
            customFields: $customFields
        ) {
            ...AddToCartOrderSummary
            ...ErrorResult
            ... on InsufficientStockError {
                message
                errorCode
            }
        }
    }
    ${ADD_TO_CART_ORDER_SUMMARY_FRAGMENT}
    ${ERROR_RESULT_FRAGMENT}
`;
